import http from '../clients/Axios'

export default class DivisiService {
  async paginate(pageNumber, pageSize = 10, sortField, sortOrder, filters) {
    pageNumber = pageNumber === undefined ? 1 : pageNumber
    const sort = sortOrder === 1 ? '-' + sortField : sortField

    let filters_param = ''

    if (filters) {
      const keys = Object.keys(filters)

      keys.forEach((el) => {
        if (filters[el].value) {
          if (el === 'ctg' || el === 'name') {
            filters_param =
              filters_param + '&' + el + '=' + filters[el].value.trim()
          } else {
            filters_param = filters_param + '&' + el + '=' + filters[el].value
          }
        }
      })
    }

    const res = await http.get(
      `/divisi/paginate?page=${pageNumber}&size=${pageSize}&sort=${sort}${filters_param}`
    )

    return res.data
  }

  async get() {
    const res = await http.get('/divisi?sort=name')
    return res.data
  }

  async getById(param) {
    param = param ? param : ''
    const res = await http.get(`/divisi${param}`)
    return res
  }

  async getList(keyword = '') {
    const res = await http.get(`/divisi?name=${keyword}`)
    return res.data
  }

  async add(form) {
    const res = await http.post('/divisi', form)
    return res
  }

  async update(id, form) {
    const res = await http.put(`/divisi/${id}`, form)
    return res
  }

  async delete(id) {
    const res = await http.delete(`/divisi/${id}`)
    return res
  }

  async generateCode() {
    const res = await http.get('/divisi/generate-code')
    return res.data
  }
}
